module.exports = __webpack_public_path__ + "img/1513748625.6ea6776d.jpg";